<template>
  <v-btn
    id="user-menu-activate"
    class="w-100 d-block px-1 plain"
    @click="signOut">
    <v-icon>mdi-account-outline</v-icon>
    <div class="mx-auto text-truncate">
      Sign Out <b>{{$store.state.user.projectName}}</b>
    </div>
    <v-icon>mdi-logout</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'UserMenu',
  methods: {
    signOut() {
      this.$store.dispatch('signOut');
      this.$router.push({ name: 'SignIn' });
    },
  },
};
</script>

<style lang="scss">
#user-menu {
  padding: 0;
}
</style>
